import React, {useEffect, useState} from 'react'
import {useSelector} from 'react-redux'
import axios from 'axios'
import _ from 'lodash'

import {Grid, Typography} from '@material-ui/core'
import "react-datepicker/dist/react-datepicker.css";
import Select from 'react-select';
import loading_gif from '../../assets/img/loading.gif'

import {ServerConfig} from 'config'

function utc_timestamp_to_local_datetime_string(ts) {
  let date_string = new Date(ts).toLocaleDateString("en-US");
  let time_string = new Date(ts).toLocaleTimeString("en-US", {timeZoneName: "short"})

  return date_string + " " + time_string;
}

const Inventory = () => {
  const token = useSelector(state => state.auth.access_token)

  const [isLoading, setIsLoading] = useState(false);
  const [inventoryData, setInventoryData] = useState([])
  const [availableCertIDs, setAvailableCertIDs] = useState([])
  const [selectedCertID, setSelectedCertID] = useState({label: 'Please Select', value: ''})

  async function fetchCertIDList(token) {
    const config = {headers: {'Content-Type': 'application/json'}}

    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }

    const results = await axios.get(`${ServerConfig.SERVER_URL}/tenant/cert_ids`, config);
    const options = [];

    for (let idx in results.data) {
      options.push({value: results.data[idx], label: results.data[idx]});
    }

    setAvailableCertIDs(options);
    if (options.length > 0) {
      setSelectedCertID(options[0]);
    }
  }

  async function fetchInventoryData(token) {
    setIsLoading(true);

    const config = {headers: {'Content-Type': 'application/json'}}

    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }

    const results = await axios.post(`${ServerConfig.SERVER_URL}/tenant/inventory`, {'cert_id': selectedCertID.value}, config)

    setInventoryData(results.data);

    setIsLoading(false);
  }

  useEffect(() => {
    if (selectedCertID.value != "") {
      fetchInventoryData(token)
    }
  }, [selectedCertID])

  useEffect(() => {
    fetchCertIDList(token);
  }, [token])


  return (
    <>
      <Grid container spacing={3}
            style={{'marginBottom': '20px', 'borderRadius': '20px', 'backgroundColor': 'white', 'padding': '20px'}}>
        <Grid xs={12} style={{'marginBottom': '20px'}}>
          <Typography variant="h2">
            Cert-ID:
          </Typography>

          {availableCertIDs.length > 0 &&
            <Select
              //isMulti
              /*className="form-select"*/
              name="machine"
              id="machine"
              onChange={(event) => {
                setSelectedCertID(event)
              }}  // [{value:'', label:''}, ...]
              options={availableCertIDs}
              defaultValue={availableCertIDs[0]}
            />
          }
        </Grid>
      </Grid>

      {isLoading &&
        <Grid container spacing={3}>
          <Grid xs={12} style={{'textAlign': 'center'}}>
            <img src={loading_gif} style={{'width': '150px'}}/>
          </Grid>
        </Grid>
      }

      {!isLoading &&
        <>
          <Grid container spacing={3} style={{'borderRadius': '20px', 'marginBottom': '20px', 'padding': '20px'}}>
            <Grid xs={12} sm={4} md={3} style={{'fontWeight': 'bold', 'color': 'gray'}}>
              Material
            </Grid>

            <Grid xs={12} sm={4} md={3} style={{'textAlign': 'right', 'fontWeight': 'bold', 'color': 'gray'}}>
              Total weight (lbs)
            </Grid>

            <Grid xs={12} sm={4} md={6} style={{'textAlign': 'right', 'fontWeight': 'bold', 'color': 'gray'}}>
              Last Shipped
            </Grid>
          </Grid>

          {_.map(inventoryData, (material_dict, material) => {
            if (material_dict['total_weight_lbs'] > 0) {
              return (
                <>
                  <Grid container spacing={3} style={{
                    'borderRadius': '20px',
                    'marginBottom': '20px',
                    'backgroundColor': 'white',
                    'padding': '20px'
                  }}>
                    <Grid xs={12} sm={4} md={3} style={{}}>
                      {material_dict['material']}
                    </Grid>

                    <Grid xs={12} sm={4} md={3} style={{'textAlign': 'right'}}>
                      {material_dict['total_weight_lbs'].toFixed(1)} lbs
                    </Grid>

                    <Grid xs={12} sm={4} md={6} style={{'textAlign': 'right'}}>
                      {material_dict['last_shipping_ts'] != "" &&
                        utc_timestamp_to_local_datetime_string(material_dict['last_shipping_ts'])}
                    </Grid>

                  </Grid>
                </>
              )
            }
          })
          }
        </>
      }
    </>
  )
}

export default Inventory
